import * as React from "react";
import DebouncedInput from "../helper/DebouncedInput";
import { rankItem } from "@tanstack/match-sorter-utils";

import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
} from "@tanstack/react-table";

import TablePageIndicator from "./TablePageIndicator";
import CustomTablePagination from "./TablePagination";
import ComponentLoader from "../ui/pageLoader/ComponentLoader";

import {
  searchIcon,
  editPencilIcon,
  deleteIconDark,
  history,
  rectangle,
} from "../../assetData/icons";
import { format } from "date-fns";
import { useState } from "react";
import { MdFilterAlt, MdOutlineFilterAlt } from "react-icons/md";

const fuzzyFilter = (row, columnId, value, addMeta) => {
  const itemRank = rankItem(row.getValue(columnId), value);
  addMeta({
    itemRank,
  });
  return itemRank.passed;
};

function MasterTable(props) {
  const {
    tableData,
    columns,
    setIsEdit,
    setIsDelete,
    setSelectedItemId,
    renderKey,
    filterField,
    actionConfig = [],
    isLoading,
    setGlobalFilters,
    name,
    loading,
    assignCoupon,
    actions,
    scripPage,
    setSelectedItem,
    setIsFilter,
    isFilter,
  } = props;

  const [data, setData] = React.useState([]);
  const [globalFilter, setGlobalFilter] = React.useState("");
  const [id, setId] = useState("");
  const [isHover, setIsHover] = useState("hidden");

  const [isHoverScript, setIsHoverScript] = useState(false);
  const [hoveredRowIdScript, setHoveredRowIdScript] = useState(null);

  const [isHoverScheme, setIsHoverScheme] = useState(false);
  const [hoveredRowIdScheme, setHoveredRowIdScheme] = useState(null);

  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const hoverEffect = (info) => {
    setIsHover("block");
    setId(info);
  };

  const removeHover = () => {
    setIsHover("hidden");
    setId("");
  };

  const hoverEffectScript = (rowId) => {
    setIsHoverScript(true);
    setHoveredRowIdScript(rowId);
  };

  const removeHoverScript = () => {
    setIsHoverScript(false);
    setHoveredRowIdScript(null);
  };

  const hoverEffectScheme = (rowId) => {
    setIsHoverScheme(true);
    setHoveredRowIdScheme(rowId);
  };

  const removeHoverScheme = () => {
    setIsHoverScheme(false);
    setHoveredRowIdScheme(null);
  };

  const customTable = useReactTable({
    data,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      globalFilter,
      pagination,
    },
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const handleEditButton = (segmentId) => {
    setIsEdit(true);
    setSelectedItemId(segmentId);
  };

  const handleDeleteButton = (segmentId) => {
    setSelectedItemId(segmentId);
    setIsDelete(true);
  };

  React.useEffect(() => {
    if (customTable.getState().columnFilters[0]?.id === "fullName") {
      if (customTable.getState().sorting[0]?.id !== "fullName") {
        customTable.setSorting([{ id: "fullName", desc: false }]);
      }
    }
  }, [customTable.getState().columnFilters[0]?.id]);

  React.useEffect(() => {
    if (tableData) setData(tableData);
  }, [tableData]);
  if (!data) return null;

  return (
    <div>
      <div className={`flex items-center justify-between ${"max-lg:w-full"} `}>
        <div></div>
        {/* Actions */}
        <div
          className={`mb-4 items-center gap-4 sm:flex sm:flex-wrap ${"max-lg:w-full"} `}
        >
          {filterField && (
            <div
              className={`${"flex justify-between max-lg:w-full max-sm:mb-4 sm:gap-[25px] max-lg:[&>div]:w-[350px] max-sm:[&>div]:w-[48%]"}`}
            >
              {name && (
                <div className="flex items-baseline justify-center rounded-md border-[1px] border-[#868686] bg-white px-1 py-1 shadow-lg sm:hidden">
                  <div
                    onClick={() => setIsFilter(true)}
                    className="flex items-center space-x-4 text-[17px] font-bold text-neutral-800 opacity-70"
                  >
                    {isFilter ? (
                      <MdFilterAlt className={`text-[17px] `} />
                    ) : (
                      <MdOutlineFilterAlt className={`text-[17px]  `} />
                    )}
                    Filter
                  </div>
                </div>
              )}
              {name !== "MutualFund" && (
                <div className="flex ">
                  <div className="flex items-center border-b-[1px] border-[#636363]">
                    <img src={searchIcon} alt="" />
                    <DebouncedInput
                      value={globalFilter ?? ""}
                      onChange={(value) => setGlobalFilters(String(value))}
                      className=" bg-transparent py-1 text-neutral-800 focus:outline-none sm:w-[170px]"
                      placeholder="Search"
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          <div
            className={`flex items-center  ${"flex flex-wrap max-sm:w-full max-sm:justify-between max-sm:gap-4 sm:gap-4 max-sm:[&>div]:w-[48%]"}`}
          >
            {actionConfig.map((action, idx) => (
              <div key={action.id} className="flex items-center gap-4">
                {idx !== 0 && (
                  <div className="h-[35px] w-[2px] bg-neutral-200 max-lg:hidden" />
                )}
                <button
                  className={`flex ${"flex justify-center text-center max-sm:w-full"} items-center gap-2 rounded border-[1px] border-[#636363] px-6 py-1 font-bold text-[#636363] ${
                    action.disable ? "opacity-[100%]" : "opacity-[55%]"
                  }`}
                  onClick={action.actionHandler}
                  disabled={!action.disable}
                >
                  <img src={action.image} alt="i4Invest" />
                  {action.name}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <TablePageIndicator
        currentNumber={customTable.getFilteredRowModel().rows?.length}
        totalNumber={data?.length}
        className={"lg:hidden"}
      />
      <div className="flex w-full items-center justify-between ">
        <TablePageIndicator
          currentNumber={customTable.getFilteredRowModel().rows?.length}
          totalNumber={data?.length}
          className={"max-lg:hidden"}
        />
        <div className="mb-4 flex w-full items-center gap-2 space-x-2 md:justify-end">
          <div className="flex w-fit items-center gap-2 space-x-2">
            <label className="text-[#868686]">Show Rows: </label>
            <select
              className="text-dropdown-text w-[100px] bg-gray-100 py-[0.4rem] text-[15px] text-[#868686] focus:outline-none"
              onChange={(e) => {
                const value =
                  e.target.value === "All"
                    ? data.length
                    : Number(e.target.value);
                setPagination((old) => ({
                  ...old,
                  pageSize: value,
                }));
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="All">All</option>
            </select>
          </div>
        </div>
      </div>
      {(loading || isLoading) && <ComponentLoader />}
      <div className="scrollbar-custom max-xl:overflow-x-scroll">
        <table className="w-full">
          <thead className=" bg-pri-clr-blue">
            {customTable.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header, index) => (
                  <th
                    key={header.id}
                    className={`border-1 whitespace-nowrap border-black px-1 py-2 text-start text-[12px] font-bold uppercase text-[#F6F6F6] ${
                      header.id === "id" ? "text-center" : ""
                    }`}
                    style={{
                      textAlign: header.id === "id" ? "center" : "left",
                      width: header.id === "name" ? "60%" : "fit",
                    }}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <thead className="h-2">
            <tr></tr>
          </thead>
          <tbody className=" border-[1px] border-neutral-clr-300  pt-2">
            {customTable.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell, index) => (
                  <td
                    key={cell.id}
                    className={`relative h-[29px] whitespace-nowrap border-[1px] border-neutral-clr-300 px-2 text-[12px] font-medium text-[#636363]`}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}

                    {cell.id.split("_")[1] === "scheme" &&
                      cell.id.split("_")[2] === "name" && (
                        <>
                          <span
                            className="w-[500px]"
                            onMouseOver={() => hoverEffectScheme(row.id)}
                            onMouseLeave={removeHoverScheme}
                          >
                            <span className="whitespace-nowrap text-[#636363]">
                              {row?.original?.scheme_name?.length > 100
                                ? row?.original?.scheme_name.substring(0, 97) +
                                  "..."
                                : row?.original?.scheme_name}
                            </span>
                          </span>
                          {isHoverScheme &&
                            hoveredRowIdScheme === row.id &&
                            row?.original?.scheme_name?.length > 100 && (
                              <span className="absolute left-[140px] z-[1000] mt-[-4px] w-fit whitespace-nowrap rounded bg-[#D9D9D9] p-[4px] text-[#636363]">
                                {row.original.scheme_name}
                              </span>
                            )}
                        </>
                      )}
                    {cell.id.split("_")[1] === "script" &&
                      cell.id.split("_")[2] === "name" &&
                      scripPage && (
                        <>
                          <span
                            className=" w-[100px]"
                            onMouseOver={() => hoverEffectScript(row.id)}
                            onMouseLeave={removeHoverScript}
                          >
                            <span className="whitespace-nowrap text-[#636363]">
                              {row?.original?.script_name?.length > 15
                                ? row?.original?.script_name.substring(0, 15) +
                                  "..."
                                : row?.original?.script_name}
                            </span>
                          </span>
                          {isHoverScript &&
                            hoveredRowIdScript === row.id &&
                            row?.original?.script_name?.length > 15 && (
                              <span className="absolute left-[140px] z-[1000] mt-[-4px] w-fit whitespace-nowrap rounded bg-[#D9D9D9] p-[4px] text-[#636363]">
                                {row.original.script_name}
                              </span>
                            )}
                        </>
                      )}
                    {cell.id.split("_")[1] === "id" && (
                      <div className="mx-auto flex w-[80px] items-center justify-evenly gap-1 px-1 [&>button]:shrink-0">
                        <>
                          <button className="relative">
                            <img
                              onMouseOver={() =>
                                hoverEffect(cell.getValue("id"))
                              }
                              onMouseLeave={() =>
                                removeHover(cell.getValue("id"))
                              }
                              src={history}
                              alt="i4invest"
                              className="w-[15px]"
                            />
                            {id === row.original.id && (
                              <div className="relative">
                                <span className="absolute z-30">
                                  <img src={rectangle} alt="" />
                                </span>
                                <span
                                  className={`${isHover} absolute left-1/2 z-30 mt-2 w-[250px] -translate-x-1/2 transform rounded-[5px] bg-[#D9D9D9] p-[5px]`}
                                >
                                  {assignCoupon ? (
                                    <span className="block text-left">
                                      {`Updated By : ${row?.original?.updated_by}`}
                                    </span>
                                  ) : (
                                    <>
                                      <span className="block text-left">
                                        {`Created At : ${format(
                                          new Date(row?.original?.created_at),
                                          "dd MMM yyyy, hh:mm:ss",
                                        )}`}
                                      </span>
                                      <span className="block text-left">
                                        {`Updated By : ${row?.original?.updated_by}`}
                                      </span>
                                      <span className="block text-left">
                                        {`Updated At : ${format(
                                          new Date(row?.original?.updated_at),
                                          "dd MMM yyyy, hh:mm:ss",
                                        )}`}
                                      </span>
                                    </>
                                  )}
                                </span>
                              </div>
                            )}
                          </button>

                          {name !== "MutualFund" && (
                            <>
                              <button
                                onClick={() => {
                                  handleEditButton(cell.getValue("id"));
                                  if (typeof setSelectedItem === "function") {
                                    setSelectedItem(cell?.row?.original);
                                  }
                                }}
                                disabled={
                                  (actions?.edit_perm &&
                                    cell.row.original.status === "Active") ||
                                  cell.row.original.status === true
                                    ? false
                                    : true
                                }
                              >
                                <img
                                  src={editPencilIcon}
                                  alt="i4invest"
                                  className={`${
                                    (actions?.edit_perm &&
                                      cell.row.original.status === "Active") ||
                                    cell.row.original.status === true
                                      ? ""
                                      : "opacity-[55%]"
                                  } `}
                                />
                                <p></p>
                              </button>

                              <button
                                onClick={() =>
                                  handleDeleteButton(cell.getValue("id"))
                                }
                                disabled={
                                  (actions?.delete_perm &&
                                    cell.row.original.status === "Active") ||
                                  cell.row.original.status === true
                                    ? false
                                    : true
                                }
                              >
                                <img
                                  src={deleteIconDark}
                                  alt="i4invest"
                                  className={`${
                                    (actions?.delete_perm &&
                                      cell.row.original.status === "Active") ||
                                    cell.row.original.status === true
                                      ? ""
                                      : "opacity-[55%]"
                                  } `}
                                />
                              </button>
                            </>
                          )}
                        </>
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data && (
        <CustomTablePagination table={customTable} renderKey={renderKey} />
      )}
    </div>
  );
}

export default React.memo(MasterTable);
